// extracted by mini-css-extract-plugin
module.exports = {"words":"style_words__zs7ro","title":"style_title__1WPkP","word":"style_word__8b6sQ","audio":"style_audio__ugWsx"};